// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"85e5c1db","70":"2d955bf2","123":"ec3e6cce","558":"0f24b398","692":"5d60bf9b"}[chunkId] + ".chunk.js";
};